import React, { createContext, useContext, useEffect, useState } from "react";
import { decryptDataFun } from "../utils/storage";
import { get } from "../utils/api";
import { getBrowserTabTitle } from "../utils/consultantLogo";

/** 🎯 User Context **/
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [module, setModule] = useState([]);
  const [selectCompany, setSelctedCompany] = useState(null);

  useEffect(() => {
    let storedUser = localStorage.getItem("user");
    if (storedUser) storedUser = decryptDataFun(storedUser);
    const storedModule = localStorage.getItem("module");
    if (storedUser) {
      setUser(storedUser);
      setModule(storedModule);
    }
    document.title = getBrowserTabTitle();
  }, []);

  // On every real page load (not on internal route navigation, since this
  // Provider only mounts once), silently refresh the few session fields
  // that can change without a re-login — a consultant's uploaded logo, or
  // an account converted Demo/Pilot -> Live.
  useEffect(() => {
    if (!sessionStorage.getItem("token")) return;

    const refreshSession = async () => {
      const res = await get("/api/auth/session-refresh");
      if (!res?.data) return;

      const newLogoUrl = res.data.consultantLogoUrl || "";
      const newIconUrl = res.data.consultantIconUrl || "";
      const newCompanyName = res.data.consultantCompanyName || "";
      const changed =
        localStorage.getItem("consultantLogoUrl") !== newLogoUrl ||
        localStorage.getItem("consultantIconUrl") !== newIconUrl ||
        localStorage.getItem("consultantCompanyName") !== newCompanyName;

      localStorage.setItem("consultantLogoUrl", newLogoUrl);
      localStorage.setItem("consultantIconUrl", newIconUrl);
      localStorage.setItem("consultantCompanyName", newCompanyName);
      setUser((prev) =>
        prev ? { ...prev, isTrialUser: res.data.isTrialUser } : prev
      );

      // Most sidebar/layout files read the logo via a plain localStorage
      // read at render time, not from this context, so they won't
      // re-render just because the value above changed — a one-time
      // reload guarantees every page picks it up correctly, however it
      // reads it.
      if (changed) {
        window.location.reload();
      }
    };
    refreshSession();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        module,
        setModule,
        selectCompany,
        setSelctedCompany,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const useUser = () => useContext(AuthContext);
